import { useModalDialog } from '@/pages/fulfillment/components/useModalDialog';

export interface AbandonAuditModalProps {
  shelves: number;
  busy: boolean;
  onAbandon: () => void;
  onClose: () => void;
}

/**
 * Abandoning closes the walk's rounds, so it is asked for rather than obeyed [D-n]. A live audit writes each count to the
 * stock as it is saved, so the counts already made stay; only the rows nobody counted are left as the book shows [SSD-7447].
 */
export const AbandonAuditModal = ({ shelves, busy, onAbandon, onClose }: AbandonAuditModalProps) => {
  const dialog = useModalDialog(onClose);

  return (
    <dialog
      className="inv-modal"
      ref={dialog}
      aria-label="Abandon the stock audit"
      onClick={(event) => event.target === event.currentTarget && onClose()}
    >
      <header>
        Abandon the stock audit?
        <button type="button" className="x" aria-label="Keep counting" onClick={onClose}>
          ✕
        </button>
      </header>
      <div className="body">
        <div className="note warn">
          {`${shelves} open ${shelves === 1 ? 'round' : 'rounds'} will be closed as abandoned. Counts already saved stay in the stock; rows not counted keep what the book shows.`}
        </div>
      </div>
      <div className="foot">
        <button type="button" className="btn btn-gray btn-sm" onClick={onClose}>
          Keep counting
        </button>
        <button type="button" className="btn btn-red-line btn-sm" disabled={busy} onClick={onAbandon}>
          Abandon the audit
        </button>
      </div>
    </dialog>
  );
};
